export default {
  setShowSubscriberModal(state, value) {
    state.showSubscriberModal = value;
  },
  setFormData(state, value) {
    state.formData = value;
  },
  setSubscribersList(state, value) {
    state.subscribersList = value;
  },
  setSubscribersListItem(state, value) {
    state.subscribersListItem = value;
  },
  setInterval(state, value) {
    state.interval = value;
  },
  setSubscribers(state, value) {
    state.subscribers = value;
  },
  setSubScriberItem(state, value) {
    state.subScriberItem = value;
  },
  setGuestItem(state, value) {
    state.guestItem = value;
  },
  showAddDialog(state) {
    state.addDialogVisible = true;
  },
  hideAddDialog(state) {
    state.addDialogVisible = false;
  },
  showUpdateDialog(state) {
    state.updateDialogVisible = true;
  },
  hideUpdateDialog(state) {
    state.updateDialogVisible = false;
  },
  setProfileId(state, value) {
    state.profileId = value;
  },
  setSubscriberProfile(state, value) {
    state.subscriberProfile = value;
  },
  setSubscriberPage(state, value) {
    state.subscriberPage = value;
  },
  setLocationIds(state, value) {
    state.locationIds = value;
  },
  setLocationGroupIds(state, value) {
    state.locationGroupIds = value;
  },
  setGuests(state, value) {
    state.guests = value;
  },
  setGuestPage(state, value) {
    state.guestPage = value;
  },
  setSubscriberPageS3(state, value) {
    state.subscriberPageS3 = value;
  },
  setGuestPageS3(state, value) {
    state.guestPageS3 = value;
  },
};
